export type LatLngTuple = [number, number]

const cache = new Map<string, LatLngTuple[]>()

export function decodePolyline(encoded: string): LatLngTuple[] {
  const cached = cache.get(encoded)
  if (cached) return cached

  const coordinates: LatLngTuple[] = []
  let index = 0
  let latitude = 0
  let longitude = 0

  while (index < encoded.length) {
    const latitudeChange = decodeChunk(encoded, index)
    index = latitudeChange.nextIndex
    const longitudeChange = decodeChunk(encoded, index)
    index = longitudeChange.nextIndex

    latitude += latitudeChange.value
    longitude += longitudeChange.value
    coordinates.push([latitude / 1e5, longitude / 1e5])
  }

  cache.set(encoded, coordinates)
  return coordinates
}

function decodeChunk(encoded: string, startIndex: number) {
  let index = startIndex
  let result = 0
  let shift = 0
  let byte = 0

  do {
    byte = encoded.charCodeAt(index++) - 63
    result |= (byte & 0x1f) << shift
    shift += 5
  } while (byte >= 0x20 && index < encoded.length)

  return {
    nextIndex: index,
    value: result & 1 ? ~(result >> 1) : result >> 1,
  }
}
